var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 70,
    rx: 21.5,
    fill: "white",
    stroke: "#56AAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 22.25C37.9837 22.25 40.8452 23.4353 42.955 25.545C45.0647 27.6548 46.25 30.5163 46.25 33.5C46.25 38.1575 42.7 43.0375 35.75 48.25C35.5336 48.4123 35.2705 48.5 35 48.5C34.7295 48.5 34.4664 48.4123 34.25 48.25C27.3 43.0375 23.75 38.1575 23.75 33.5C23.75 30.5163 24.9353 27.6548 27.045 25.545C29.1548 23.4353 32.0163 22.25 35 22.25ZM35 29.75C34.0054 29.75 33.0516 30.1451 32.3483 30.8483C31.6451 31.5516 31.25 32.5054 31.25 33.5C31.25 34.4946 31.6451 35.4484 32.3483 36.1517C33.0516 36.8549 34.0054 37.25 35 37.25C35.9946 37.25 36.9484 36.8549 37.6517 36.1517C38.3549 35.4484 38.75 34.4946 38.75 33.5C38.75 32.5054 38.3549 31.5516 37.6517 30.8483C36.9484 30.1451 35.9946 29.75 35 29.75Z",
    fill: "#56AAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.970aeaa896983122f16209f353f02419.svg";
export { ForwardRef as ReactComponent };